// Aides des écrans hors connexion : formats de durée et lecture des erreurs
// renvoyées par l'API pour les liens reçus par e-mail.

/** 65 → "1:05" */
export function formaterDuree(secondes) {
  const s = Math.max(0, Math.floor(secondes || 0));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

/** 300 → "5 minutes", 60 → "1 minute", 90 → "90 secondes" */
export function formaterValidite(secondes) {
  const s = Math.max(0, Math.floor(secondes || 0));
  if (s >= 60 && s % 60 === 0) {
    const m = s / 60;
    return `${m} minute${m > 1 ? "s" : ""}`;
  }
  return `${s} seconde${s > 1 ? "s" : ""}`;
}

/** Message texte d'une réponse d'erreur (objet {other|error|token|password}, chaîne, ou rien). */
export function messageErreur(donnees) {
  if (!donnees) return "";
  if (typeof donnees === "string") return donnees;
  return donnees.other || donnees.error || donnees.token || donnees.password || donnees.message || "";
}

/**
 * Traduit l'échec d'un lien (activation, réinitialisation) en écran à afficher :
 * "expire" | "utilise" | "invalide" | "indisponible" (serveur injoignable ou en erreur).
 * Couvre les libellés de l'API actuelle (« Ce lien a expiré. », « Ce lien a déjà été
 * utilisé. », « Ce lien est invalide. ») et ceux de l'ancienne (« Ce lien est expiré »,
 * « Ce lien n'est plus valide », « Le jeton … a déjà été utilisé »).
 */
export function interpreterErreurLien(err) {
  const reponse = err && err.response;
  const message = messageErreur(reponse && reponse.data);
  if (/expir/i.test(message)) return "expire";
  if (/d[ée]j[àa] [ée]t[ée] utilis[ée]|plus valide/i.test(message)) return "utilise";
  if (/invalide|introuvable|incorrect|n'existe|ne correspond/i.test(message)) return "invalide";
  if (!reponse || reponse.status >= 500) return "indisponible";
  return "invalide";
}

export const MESSAGE_MOT_DE_PASSE_DEJA_UTILISE =
  "Ce mot de passe a déjà été utilisé récemment. Choisissez-en un nouveau.";

/**
 * Message à afficher sous le champ « nouveau mot de passe », ou null si l'erreur
 * ne concerne pas le mot de passe (lien, serveur…).
 * API actuelle : { password: "…" } ; ancienne : chaîne nue (règle non respectée)
 * ou { other: "Ce mot de passe est trop proche d'un de vos anciens mot de passe" }.
 */
export function extraireErreurMotDePasse(donnees) {
  if (!donnees) return null;
  if (typeof donnees === "string") return /ancien|proche/i.test(donnees) ? MESSAGE_MOT_DE_PASSE_DEJA_UTILISE : donnees;
  if (donnees.password) {
    return /ancien|proche|d[ée]j[àa]/i.test(donnees.password) ? MESSAGE_MOT_DE_PASSE_DEJA_UTILISE : donnees.password;
  }
  if (donnees.other && /mot de passe/i.test(donnees.other) && /ancien|proche/i.test(donnees.other)) {
    return MESSAGE_MOT_DE_PASSE_DEJA_UTILISE;
  }
  return null;
}

export const MESSAGE_SERVEUR_INDISPONIBLE =
  "Le serveur n'a pas répondu. Vérifiez votre connexion et réessayez dans un instant.";
